'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dSwitcher$00241 from "./samples.-Sealed$package$-Switcher$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Switcher$3$(sealedVar$6, Switcher$lzy1$4) {
  this.kd = null;
  this.wp = null;
  this.kd = sealedVar$6;
  this.wp = Switcher$lzy1$4;
}
export { $c_Lsamples_Sealed$package$Switcher$3$ as $c_Lsamples_Sealed$package$Switcher$3$ };
$p = $c_Lsamples_Sealed$package$Switcher$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Switcher$3$;
/** @constructor */
function $h_Lsamples_Sealed$package$Switcher$3$() {
}
export { $h_Lsamples_Sealed$package$Switcher$3$ as $h_Lsamples_Sealed$package$Switcher$3$ };
$h_Lsamples_Sealed$package$Switcher$3$.prototype = $p;
$p.UG = (function(x$0) {
  return new $j_samples$002e$002dSealed$0024package$0024$002dSwitcher$00241.$c_Lsamples_Sealed$package$Switcher$1(x$0.g(0), x$0.g(1));
});
$p.y = (function(p) {
  return this.UG(p);
});
var $d_Lsamples_Sealed$package$Switcher$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Switcher$3$, "samples.Sealed$package$Switcher$3$", ({
  qQ: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Sealed$package$Switcher$3$ as $d_Lsamples_Sealed$package$Switcher$3$ };
